import { InfoOutlined } from "@mui/icons-material";
import React from "react";
import { openMessageModal } from "../../../utils/common";

type MinCartPriceInfoProps = {
  promoType: string;
  minBasketPrice: string | number;
  allowPromoCodes?: boolean;
};

export default function MinCartPriceInfo({
  promoType,
  minBasketPrice,
  allowPromoCodes,
}: MinCartPriceInfoProps) {
  const textPromo = promoType === "code-promo" ? "Code promo" : "Fidélité";

  const modalTitle = allowPromoCodes
    ? `${textPromo}\nnon applicable !`
    : "Code promo\nnon applicable";

  return (
    <InfoOutlined
      className="ml-2 infoIcon"
      style={{ color: "red" }}
      onClick={() => {
        openMessageModal(
          allowPromoCodes
            ? `<span>
          Afin de
          <b> profiter de votre ${
            promoType === "code-promo" ? "code promo" : "fidélité"
          },</b>
          votre panier de commande doit être
          <b> supérieur à ${minBasketPrice}€</b>
        </span>`
            : "Votre code promotionnel n’est pas cumulable avec les offres promotionnelles présentes dans votre panier",
          {
            text: modalTitle,
            buttonName: "J’ai compris",
          },
        );
      }}
    />
  );
}
